export default "__VITE_ASSET__CQyJnAl2__"